import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import dashboardService from "../../services/dashboardService";

// Load Dashboard Data
export const fetchDashboard = createAsyncThunk(
    "dashboard/fetchDashboard",
    async (_, thunkAPI) => {
        try {
            return await dashboardService.getDashboard();
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || "Unable to load dashboard."
            );
        }
    }
);

const initialState = {
    data: {
        totalBanks: 0,
		totalBuyers: 0,
		totalDespatcho: 0,
		totalPorts: 0,
		totalRedex: 0,
		totalShipping: 0,
		totalSupplier: 0,
		totalTransporter: 0,
		totalUsers: 0,
        latestBanks: [],
		latestLedgers: [],
        latestCourses: []
    },
    loading: false,
    error: null
};

const dashboardSlice = createSlice({
    name: "dashboard",

    initialState,

    reducers: {
        clearDashboard: (state) => {
            state.data = {
                totalBanks: 0,
				totalBuyers: 0,
				totalDespatcho: 0,
				totalPorts: 0,
				totalRedex: 0,
				totalShipping: 0,
				totalSupplier: 0,
				totalTransporter: 0,
				totalUsers: 0,
                latestBanks: [],
				latestLedgers: [],
				latestBuyers: [],
				latestDespatcho: [],
				latestPort: [],
				latestRedex: [],
				latestShipping: [],
				latestSupplier: [],
                latestTransporter: []
            };
            state.error = null;
        }
    },

    extraReducers: (builder) => {

        builder

            .addCase(fetchDashboard.pending, (state) => {
                state.loading = true;
                state.error = null;
            })

            .addCase(fetchDashboard.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })

            .addCase(fetchDashboard.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });

    }
});

export const { clearDashboard } = dashboardSlice.actions;

export default dashboardSlice.reducer;